import(/* webpackMode: "eager" */ "/vercel/path0/app/(app)/goals/page.tsx");
